// removed by extract-text-webpack-plugin
module.exports = {"category-merge-modal":"category-merge-modal","modal-body":"modal-body","merge-description":"merge-description","fallback-section":"fallback-section","button-select-fallback":"button-select-fallback","fallback-category-preview":"fallback-category-preview","category-name":"category-name","fallback-empty":"fallback-empty"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/category-merge-modal/category-merge-modal.style.sass
// module id = dpaq
// module chunks = 0